/**
 * wizardly.ai - Smart Icon System
 *
 * Canvas-based icon rendering with keyword-to-icon mapping
 * Similar to Gamma's Pictograph icons system
 */

// Icon paths (simplified SVG path data for Canvas rendering)
// These are optimized versions of Lucide icons
const ICON_PATHS = {
  // Business & Finance
  'chart': 'M3 3v18h18M9 17V9m4 8V5m4 12v-6',
  'trending-up': 'M23 6l-9.5 9.5-5-5L1 18',
  'dollar': 'M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6',
  'briefcase': 'M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zM16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16',
  'building': 'M6 22V4a2 2 0 012-2h8a2 2 0 012 2v18zM6 12H4a2 2 0 00-2 2v6a2 2 0 002 2h2M18 9h2a2 2 0 012 2v9a2 2 0 01-2 2h-2M10 6h4M10 10h4M10 14h4M10 18h4',
  'piggy-bank': 'M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2h0V5z',

  // Technology
  'laptop': 'M20 16V7a2 2 0 00-2-2H6a2 2 0 00-2 2v9m16 0H4m16 0l1.28 2.55a1 1 0 01-.9 1.45H3.62a1 1 0 01-.9-1.45L4 16',
  'smartphone': 'M12 18h.01M17 2H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V4a2 2 0 00-2-2z',
  'code': 'M16 18l6-6-6-6M8 6l-6 6 6 6',
  'database': 'M21 5c0 1.1-4 2-9 2s-9-.9-9-2m18 0c0-1.1-4-2-9-2s-9 .9-9 2m18 0v14c0 1.1-4 2-9 2s-9-.9-9-2V5m18 7c0 1.1-4 2-9 2s-9-.9-9-2',
  'cloud': 'M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z',
  'server': 'M2 9a2 2 0 012-2h16a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V9zm0 7a2 2 0 012-2h16a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm4-6h.01M6 18h.01',
  'cpu': 'M9 3v2m6-2v2M9 19v2m6-2v2M3 9h2m-2 6h2m14-6h2m-2 6h2M6 9a3 3 0 013-3h6a3 3 0 013 3v6a3 3 0 01-3 3H9a3 3 0 01-3-3V9zm3 2h6m-6 4h6',

  // People & Communication
  'users': 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2m22 0v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75M9 7a4 4 0 110 8 4 4 0 010-8z',
  'user': 'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2m8-10a4 4 0 110-8 4 4 0 010 8z',
  'message': 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
  'mail': 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm16 2l-8 5-8-5',
  'phone': 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z',
  'globe': 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z',

  // Actions & States
  'check': 'M20 6L9 17l-5-5',
  'check-circle': 'M22 11.08V12a10 10 0 11-5.93-9.14M22 4L12 14.01l-3-3',
  'star': 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
  'heart': 'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z',
  'award': 'M12 15l-3 6.5 1-4-3 .5 5-7M12 15l3 6.5-1-4 3 .5-5-7M8.21 13.89L7 23l5-3 5 3-1.21-9.12M12 8a4 4 0 100-8 4 4 0 000 8z',
  'target': 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 18a6 6 0 100-12 6 6 0 000 12zm0-4a2 2 0 100-4 2 2 0 000 4z',
  'flag': 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7',

  // Time & Calendar
  'clock': 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 6v6l4 2',
  'calendar': 'M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zM16 2v4M8 2v4M3 10h18',
  'hourglass': 'M5 22h14M5 2h14M12 12L8.5 8C7.5 7 7 5.5 7 4V2h10v2c0 1.5-.5 3-1.5 4L12 12zm0 0l3.5 4c1 1 1.5 2.5 1.5 4v2H7v-2c0-1.5.5-3 1.5-4L12 12z',

  // Navigation & Location
  'map-pin': 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0zM12 13a3 3 0 100-6 3 3 0 000 6z',
  'compass': 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12z',
  'navigation': 'M3 11l19-9-9 19-2-8-8-2z',

  // Objects
  'lightbulb': 'M9 18h6M10 22h4M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0018 8 6 6 0 006 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 018.91 14',
  'rocket': 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09zM12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z',
  'shield': 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  'lock': 'M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2zm-2 0V7a5 5 0 00-10 0v4',
  'key': 'M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4',

  // Nature & Environment
  'sun': 'M12 17a5 5 0 100-10 5 5 0 000 10zM12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42',
  'moon': 'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z',
  'leaf': 'M11 20A7 7 0 019.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10zM2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12',
  'tree': 'M12 22v-7m-8 2a8 8 0 1116 0M9 20h6',

  // Media & Content
  'play': 'M5 3l14 9-14 9V3z',
  'pause': 'M6 4h4v16H6zM14 4h4v16h-4z',
  'image': 'M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zM8.5 10a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm12.5 9l-5-5-3 3-3-3-5 5',
  'video': 'M23 7l-7 5 7 5V7zM14 5H3a2 2 0 00-2 2v10a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2z',
  'music': 'M9 18V5l12-2v13M9 18a3 3 0 11-6 0 3 3 0 016 0zm12-2a3 3 0 11-6 0 3 3 0 016 0z',

  // Arrows & Direction
  'arrow-right': 'M5 12h14m-7-7l7 7-7 7',
  'arrow-left': 'M19 12H5m7 7l-7-7 7-7',
  'arrow-up': 'M12 19V5m-7 7l7-7 7 7',
  'arrow-down': 'M12 5v14m7-7l-7 7-7-7',
  'chevron-right': 'M9 18l6-6-6-6',
  'chevron-down': 'M6 9l6 6 6-6',
  'refresh': 'M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15',

  // Files & Documents
  'file': 'M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9zM13 2v7h7',
  'folder': 'M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z',
  'clipboard': 'M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2M9 2h6a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1V3a1 1 0 011-1z',
  'book': 'M4 19.5A2.5 2.5 0 016.5 17H20M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z',

  // Shopping & Commerce
  'shopping-cart': 'M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6M9 22a1 1 0 110-2 1 1 0 010 2zm11 0a1 1 0 110-2 1 1 0 010 2z',
  'package': 'M16.5 9.4l-9-5.19M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16zM3.27 6.96L12 12.01l8.73-5.05M12 22.08V12',
  'tag': 'M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82zM7 7h.01',
  'credit-card': 'M21 4H3a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2zM1 10h22',

  // Health & Science
  'activity': 'M22 12h-4l-3 9L9 3l-3 9H2',
  'heart-pulse': 'M19.5 12.572l-7.5 7.428-7.5-7.428A5 5 0 1112 6.006a5 5 0 017.5 6.572z',
  'flask': 'M9 3h6M10 9V3m4 6V3M5 21h14l-4.5-9H9.5L5 21z',
  'microscope': 'M6 18h8M3 22h18M14 22a7 7 0 100-14h-1M9 14h2M7 12V6l5 3-5 3z',

  // Industry specific
  'zap': 'M13 2L3 14h9l-1 8 10-12h-9l1-8z',
  'battery': 'M23 13v-2M17 6H3a2 2 0 00-2 2v8a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2z',
  'wifi': 'M5 12.55a11 11 0 0114.08 0M1.42 9a16 16 0 0121.16 0M8.53 16.11a6 6 0 016.95 0M12 20h.01',
  'settings': 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z',
  'tool': 'M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z',
};

// Keyword to icon mapping for intelligent auto-selection
const KEYWORD_ICON_MAP = {
  // Growth & Progress
  'growth': 'trending-up',
  'increase': 'trending-up',
  'revenue': 'dollar',
  'profit': 'dollar',
  'money': 'dollar',
  'sales': 'chart',
  'analytics': 'chart',
  'data': 'chart',
  'metrics': 'chart',
  'statistics': 'chart',
  'performance': 'activity',

  // Business
  'business': 'briefcase',
  'company': 'building',
  'office': 'building',
  'enterprise': 'building',
  'corporate': 'building',
  'organization': 'users',
  'savings': 'piggy-bank',
  'investment': 'trending-up',

  // Technology
  'technology': 'cpu',
  'tech': 'laptop',
  'computer': 'laptop',
  'software': 'code',
  'development': 'code',
  'programming': 'code',
  'coding': 'code',
  'database': 'database',
  'cloud': 'cloud',
  'server': 'server',
  'digital': 'smartphone',
  'mobile': 'smartphone',
  'app': 'smartphone',
  'innovation': 'lightbulb',
  'idea': 'lightbulb',

  // People & Teams
  'team': 'users',
  'people': 'users',
  'customer': 'user',
  'client': 'user',
  'user': 'user',
  'audience': 'users',
  'employee': 'user',
  'staff': 'users',
  'collaboration': 'users',

  // Communication
  'communication': 'message',
  'message': 'message',
  'chat': 'message',
  'email': 'mail',
  'contact': 'phone',
  'call': 'phone',
  'global': 'globe',
  'international': 'globe',
  'worldwide': 'globe',

  // Time & Planning
  'time': 'clock',
  'schedule': 'calendar',
  'deadline': 'clock',
  'planning': 'calendar',
  'date': 'calendar',
  'event': 'calendar',
  'milestone': 'flag',
  'history': 'hourglass',

  // Goals & Success
  'goal': 'target',
  'objective': 'target',
  'target': 'target',
  'success': 'award',
  'achievement': 'award',
  'winner': 'award',
  'quality': 'star',
  'premium': 'star',
  'excellent': 'star',
  'best': 'star',
  'love': 'heart',
  'favorite': 'heart',
  'complete': 'check-circle',
  'done': 'check',
  'verified': 'check-circle',
  'approved': 'check-circle',

  // Location & Navigation
  'location': 'map-pin',
  'place': 'map-pin',
  'address': 'map-pin',
  'direction': 'compass',
  'navigate': 'navigation',
  'map': 'map-pin',

  // Security & Trust
  'security': 'shield',
  'secure': 'lock',
  'protection': 'shield',
  'privacy': 'lock',
  'safe': 'shield',
  'trust': 'shield',
  'key': 'key',
  'access': 'key',

  // Environment & Nature
  'environment': 'leaf',
  'sustainable': 'leaf',
  'green': 'leaf',
  'eco': 'leaf',
  'nature': 'tree',
  'energy': 'zap',
  'power': 'zap',

  // Media & Content
  'video': 'video',
  'media': 'play',
  'content': 'file',
  'document': 'file',
  'file': 'file',
  'folder': 'folder',
  'image': 'image',
  'photo': 'image',
  'music': 'music',
  'audio': 'music',
  'book': 'book',
  'learning': 'book',
  'education': 'book',
  'knowledge': 'book',

  // Commerce
  'shopping': 'shopping-cart',
  'cart': 'shopping-cart',
  'purchase': 'shopping-cart',
  'product': 'package',
  'delivery': 'package',
  'shipping': 'package',
  'price': 'tag',
  'discount': 'tag',
  'offer': 'tag',
  'payment': 'credit-card',

  // Health & Science
  'health': 'heart-pulse',
  'medical': 'activity',
  'science': 'flask',
  'research': 'microscope',
  'laboratory': 'flask',

  // Actions
  'start': 'play',
  'launch': 'rocket',
  'fast': 'zap',
  'quick': 'zap',
  'speed': 'zap',
  'refresh': 'refresh',
  'update': 'refresh',
  'sync': 'refresh',
  'settings': 'settings',
  'configure': 'settings',
  'options': 'settings',
  'tools': 'tool',
  'build': 'tool',

  // Network & Connectivity
  'network': 'wifi',
  'connect': 'wifi',
  'wireless': 'wifi',
  'internet': 'globe',
  'online': 'globe',
};

/**
 * Parse SVG path data and draw on canvas
 */
function drawPath(ctx, pathData, x, y, size, color) {
  ctx.save();
  ctx.translate(x, y);
  ctx.scale(size / 24, size / 24); // Icons are designed for 24x24

  ctx.strokeStyle = color;
  ctx.fillStyle = color;
  ctx.lineWidth = 2;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';

  const path = new Path2D(pathData);
  ctx.stroke(path);

  ctx.restore();
}

/**
 * Render an icon on canvas
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {string} iconName - Name of the icon to render
 * @param {number} x - X position (center)
 * @param {number} y - Y position (center)
 * @param {number} size - Icon size in pixels
 * @param {string} color - Icon color
 * @param {object} options - Additional options (background, etc.)
 */
export function renderIcon(ctx, iconName, x, y, size, color, options = {}) {
  const {
    backgroundColor = null,
    backgroundRadius = size * 0.7,
    backgroundPadding = size * 0.3
  } = options;

  // Draw background if specified
  if (backgroundColor) {
    ctx.fillStyle = backgroundColor;
    ctx.beginPath();
    ctx.arc(x + size / 2, y + size / 2, backgroundRadius, 0, Math.PI * 2);
    ctx.fill();
  }

  // Get icon path
  const pathData = ICON_PATHS[iconName] || ICON_PATHS['star']; // Default to star if not found

  if (!pathData) return;

  // Draw the icon
  drawPath(ctx, pathData, x, y, size, color);
}

/**
 * Auto-select icon based on text content
 * @param {string} text - Text to analyze
 * @returns {string} - Best matching icon name
 */
export function selectIconForContent(text) {
  if (!text) return 'star';

  const lowerText = text.toLowerCase();

  // Check for direct keyword matches
  for (const [keyword, icon] of Object.entries(KEYWORD_ICON_MAP)) {
    if (lowerText.includes(keyword)) {
      return icon;
    }
  }

  // Default icons based on general content patterns
  if (/^\d+[%$]|[%$]\d+|\d+[kmb]/i.test(text)) return 'chart'; // Numbers/stats
  if (/^step|^phase|^\d+\./i.test(text)) return 'chevron-right'; // Steps
  if (/question|faq|\?$/i.test(text)) return 'message'; // Questions
  if (/contact|reach|email/i.test(text)) return 'mail'; // Contact

  return null; // No keyword match — caller assigns rotating default
}

// Rotating default icons for variety when no keyword matches
const DEFAULT_ICONS = ['check-circle', 'zap', 'target', 'compass', 'bookmark', 'globe'];

/**
 * Get a list of icons for bullet points
 * @param {string[]} bullets - Array of bullet point texts
 * @returns {string[]} - Array of icon names
 */
export function selectIconsForBullets(bullets) {
  if (!bullets || bullets.length === 0) return [];

  return bullets.map((bullet, i) => {
    const matched = selectIconForContent(bullet);
    return matched || DEFAULT_ICONS[i % DEFAULT_ICONS.length];
  });
}

/**
 * Get all available icon names
 */
export function getAvailableIcons() {
  return Object.keys(ICON_PATHS);
}

/**
 * Render a simple shape (for layouts that need basic shapes)
 */
export function renderShape(ctx, type, x, y, width, height, color, options = {}) {
  const {
    fill = true,
    stroke = false,
    strokeWidth = 2,
    radius = 0
  } = options;

  ctx.fillStyle = color;
  ctx.strokeStyle = color;
  ctx.lineWidth = strokeWidth;

  switch (type) {
    case 'circle':
      ctx.beginPath();
      ctx.arc(x + width / 2, y + height / 2, Math.min(width, height) / 2, 0, Math.PI * 2);
      if (fill) ctx.fill();
      if (stroke) ctx.stroke();
      break;

    case 'rect':
    case 'rectangle':
      if (radius > 0) {
        roundRect(ctx, x, y, width, height, radius);
      } else {
        ctx.beginPath();
        ctx.rect(x, y, width, height);
      }
      if (fill) ctx.fill();
      if (stroke) ctx.stroke();
      break;

    case 'triangle':
      ctx.beginPath();
      ctx.moveTo(x + width / 2, y);
      ctx.lineTo(x + width, y + height);
      ctx.lineTo(x, y + height);
      ctx.closePath();
      if (fill) ctx.fill();
      if (stroke) ctx.stroke();
      break;

    case 'diamond':
      ctx.beginPath();
      ctx.moveTo(x + width / 2, y);
      ctx.lineTo(x + width, y + height / 2);
      ctx.lineTo(x + width / 2, y + height);
      ctx.lineTo(x, y + height / 2);
      ctx.closePath();
      if (fill) ctx.fill();
      if (stroke) ctx.stroke();
      break;

    case 'hexagon':
      const a = Math.PI / 3;
      const r = Math.min(width, height) / 2;
      ctx.beginPath();
      for (let i = 0; i < 6; i++) {
        const px = x + width / 2 + r * Math.cos(a * i - Math.PI / 2);
        const py = y + height / 2 + r * Math.sin(a * i - Math.PI / 2);
        if (i === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
      }
      ctx.closePath();
      if (fill) ctx.fill();
      if (stroke) ctx.stroke();
      break;

    default:
      // Default to rectangle
      ctx.beginPath();
      ctx.rect(x, y, width, height);
      if (fill) ctx.fill();
      if (stroke) ctx.stroke();
  }
}

/**
 * Helper: Draw rounded rectangle
 */
function roundRect(ctx, x, y, width, height, radius) {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
}

export default {
  renderIcon,
  selectIconForContent,
  selectIconsForBullets,
  getAvailableIcons,
  renderShape,
  ICON_PATHS,
  KEYWORD_ICON_MAP,
};
